import React from "react";
import {
  Grid,
  Card,
  CardMedia,
  Typography,
  TextField,
  Button,
  Box,
  Divider,
} from "@mui/material";

const products = [
  {
    id: "feature-1",
    img: require("../../assets/vivre/HospitalityLogo.png"),
    name: "VIVRE",
    desc: "Experience. Engage. Monetize",
    extra1: "Immersive guest engagement platform",
    extra2: "Tailored for hotels and hospitality",
  },
  {
    id: "feature-2",
    img: require("../../assets/aboutus/Sara.png"),
    name: "S.A.R.A.",
    desc: "Content Discovery. Immersive. Monetize",
    extra1: "Smart AI-powered recommendations",
    extra2: "Boosts audience interaction",
  },
  {
    id: "feature-3",
    img: require("../../assets/nblink/Saralogo.png"),
    name: "Blinks",
    desc: "User Generated Content. Gamification",
    extra1: "Gamified experiences for users",
    extra2: "Encourages active participation",
  },
  {
    id: "feature-4",
    img: require("../../assets/hospitality/logo1.png"),
    name: "Horizon Hospitality Suite",
    desc: "Entertainment. Hotel Service Aggregation",
    extra1: "Centralized hotel services",
    extra2: "Seamless guest experiences",
  },
  {
    id: "feature-5",
    img: require("../../assets/products/HZAD.png"),
    name: "AdPilot",
    desc: "Promote . Analytics . Monetize",
    extra1: "Ad optimization engine",
    extra2: "Boosts ROI and conversions",
  },
  {
    id: "feature-6",
    img: require("../../assets/products/reelcraft-removebg-preview.png"),
    name: "ReelCraft",
    desc: "Promote Content. Enrich Metadata. Commercialise",
    extra1: "Empowers creators",
    extra2: "Enhances discoverability",
  },
];

export default function ProductsWithForm() {
  return (
    <Box sx={{ flexGrow: 1, bgcolor: "black", color: "white", p: 4 }}>
      <Grid container spacing={4}>
        {/* Left Side - Products */}
        <Grid item xs={12} md={6}>
          <Typography
            variant="h4"
            sx={{
              mb: 3,
              fontWeight: "bold",
              textAlign: "center",
              fontSize: "2.3rem", // ~15% bigger
            }}
          >
            Our Products
          </Typography>

          <Grid container direction="column" spacing={2}>
            {products.map((p, index) => (
              <Grid item key={p.id}>
<Card
  sx={{
    bgcolor: "#1e1e1e",
    color: "#fff",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.5)",
    p: 3,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-6px)",
      boxShadow: "0 8px 24px rgba(0,0,0,0.6)",
      background: "linear-gradient(135deg, #ffffff, #87ceeb)", 
      color: "#000",
    },
  }}
>
  <CardMedia
    component="img"
    image={p.img}
    alt={p.name}
    sx={{
      height: 80,
      width: 80,
      borderRadius: "8px",
      objectFit: "contain",
      mb: 2,
    }}
  />
  <Typography
    variant="h6"
    sx={{ fontWeight: "bold", mb: 1, fontSize: "1.2rem" }}  // slightly bigger + bold
  >
    {p.name}
  </Typography>
  <Typography
    variant="subtitle1"
    sx={{ mb: 1, fontSize: "1.05rem", fontWeight: 500 }} // medium bold
  >
    {p.desc}
  </Typography>
  <Typography variant="body2" sx={{ fontSize: "0.97rem", fontWeight: 500 }}>
    {p.extra1}
  </Typography>
  <Typography variant="body2" sx={{ fontSize: "0.97rem", fontWeight: 500 }}>
    {p.extra2}
  </Typography>
</Card>

                {/* Divider between product cards */}
                {index < products.length - 1 && (
                  <Divider sx={{ bgcolor: "#333", my: 2 }} />
                )}
              </Grid>
            ))}
          </Grid>
        </Grid>

        {/* Right Side - Form */}
        <Grid item xs={12} md={6}>
          <Typography
            variant="h4"
            sx={{
              mb: 3,
              fontWeight: "bold",
              textAlign: "center",
              fontSize: "2.3rem", // 15% larger
            }}
          >
            Book a Meeting
          </Typography>

          <Card
            sx={{
              bgcolor: "#1e1e1e",
              color: "#fff",
              borderRadius: "12px",
              p: 4,
            }}
          >
            <form>
              <TextField
                fullWidth
                label="Name"
                variant="outlined"
                margin="normal"
                InputLabelProps={{ style: { color: "#aaa" } }}
                sx={{
                  input: { color: "white", fontSize: "1.05rem" },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: "#555" },
                    "&:hover fieldset": { borderColor: "#888" },
                  },
                }}
              />
              <TextField
                fullWidth
                label="Email"
                variant="outlined"
                margin="normal"
                InputLabelProps={{ style: { color: "#aaa" } }}
                sx={{
                  input: { color: "white", fontSize: "1.05rem" },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: "#555" },
                    "&:hover fieldset": { borderColor: "#888" },
                  },
                }}
              />
              <TextField
                fullWidth
                label="Company"
                variant="outlined"
                margin="normal"
                InputLabelProps={{ style: { color: "#aaa" } }}
                sx={{
                  input: { color: "white", fontSize: "1.05rem" },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: "#555" },
                    "&:hover fieldset": { borderColor: "#888" },
                  },
                }}
              />
              <TextField
                fullWidth
                label="Message"
                variant="outlined"
                margin="normal"
                multiline
                rows={4}
                InputLabelProps={{ style: { color: "#aaa" } }}
                sx={{
                  textarea: { color: "white", fontSize: "1.05rem" },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: "#555" },
                    "&:hover fieldset": { borderColor: "#888" },
                  },
                }}
              />
              <Button
                type="submit"
                variant="contained"
                onClick
                sx={{
                  mt: 2,
                  bgcolor: "#1976d2",
                  "&:hover": { bgcolor: "#125a9c" },
                  fontSize: "1.1rem", // 15% larger
                  borderRadius:"20px"
                }}
              >
                Submit
              </Button>
            </form>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}
